export class CompanyBankDetails {
  id: string = '';
  phone: string = '';
  sort_code: string = '';
  account_number: string = '';
  account_name: string = '';
}
